// @react/hooks/useSubscriptionBundle.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { subscriptionBundleStore } from '@core/stores';

/**
 * React hook for ProductBundle operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSubscriptionBundle } from '@react/hooks';
 *
 * const ProductBundleList = observer(() => {
 *   const store = useSubscriptionBundle();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSubscriptionBundle() {
  return subscriptionBundleStore;
}
